import { lazy, Suspense } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { SuspenseFallback } from '../../../components/SuspenseFallback'

const DataStatsDashboard = lazy(() =>
  import('../../../features/admin/DataStatsDashboard').then((m) => ({
    default: m.DataStatsDashboard,
  })),
)

/* ───── Route Definition ───── */

export const Route = createFileRoute('/_authenticated/admin/data-stats')({
  component: AdminDataStatsRoute,
})

/* ───── Route Component ───── */

function AdminDataStatsRoute() {
  return (
    <Suspense fallback={<SuspenseFallback message="Loading statistics..." />}>
      <DataStatsDashboard />
    </Suspense>
  )
}
